module.exports = __webpack_public_path__ + "static/media/documents-2.da6e762c.svg";